<template>
  <div>
    The thrust duration represent the maximum amount of time the thruster have to fired on an orbital arc.
    This value is defined by the user and cannot exceed the maximum thrust duration defined at propulsion level
    which is considered as a strict constraint.
    Below we provide the corresponding <katex-element expression="\Delta V" /> which depends on spacecraft mass and propulsion system.
    The <katex-element expression="\Delta V" /> is computed as follow :
    <div class="text-xs-center">
      <br />
      <br />
      <katex-element expression="T_{consumption} (kg/s) = \dfrac{T_{thruster}}{T_{isp} g_0}" />
      <br />
      <br />
      <katex-element expression="M_{consumption} (kg) = T_{consumption} \Delta T " />
      <br />
      <br />
      <katex-element expression="\Delta V_{max} (m/s) = T_{isp} g_0 log{\dfrac{spacecraft_{mass}}{spacecraft_{mass} - M_{consumption}}}" />
      <br />
      <br />
      Where :
      <br />
      <br />
      <katex-element expression="T_{isp} (s)" /> is the Thruster specific impulsion.
      <br />
      <br />
      <katex-element expression="T_{thruster} (N)" /> is the Thruster force.
      <br />
      <br />
      <katex-element expression="\Delta T (s)" /> is the Thruster on-time duration.
      <br />
      <br />
      <katex-element expression="g_0 (kg/s^2)" /> is the Earth gravitational constant.
    </div>
  </div>
</template>

<script>
export default {
  name: 'tooltipThrustDuration'
}
</script>
